import { theme } from '@styles/theme';

export const CHIP_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  height: 32,
  px: { lg: '10px', xl: '12px' },
  py: '5px',
  minWidth: 0,
  bgcolor: theme.palette.grey[100],
  borderRadius: '8px',
  cursor: 'pointer',
  userSelect: 'none' as const,
  '&:hover': { bgcolor: theme.palette.grey.A100 },
};

// Three chips now share the top bar (session + main centre + centre), so a long
// city name has to truncate rather than push the nav or the profile menu out of
// the row. The full value is always readable in the chip's own dropdown.
export const CHIP_LABEL_SX = {
  fontSize: '12px',
  fontWeight: 600,
  color: theme.palette.grey[700],
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: { lg: 92, xl: 150 },
};

export const MENU_PAPER_SX = { mt: '4px', borderRadius: '8px', minWidth: 160 };
